import React from 'react';
import { Box } from '@mui/material';
import { getApiBaseUrl } from '../services/api';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PsychologyIcon from '@mui/icons-material/Psychology';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import HealingIcon from '@mui/icons-material/Healing';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import ScienceIcon from '@mui/icons-material/Science';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import ElderlyIcon from '@mui/icons-material/Elderly';
import PregnantWomanIcon from '@mui/icons-material/PregnantWoman';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HearingIcon from '@mui/icons-material/Hearing';

const iconMap = {
  emergency: LocalHospitalIcon,
  favorite: FavoriteIcon,
  psychology: PsychologyIcon,
  child_care: ChildCareIcon,
  accessibility: AccessibilityIcon,
  healing: HealingIcon,
  local_hospital: LocalHospitalIcon,
  medical_services: MedicalServicesIcon,
  stethoscope: MedicalServicesIcon,
  monitor_heart: MonitorHeartIcon,
  brain: PsychologyIcon,
  elderly: ElderlyIcon,
  pregnant_woman: PregnantWomanIcon,
  visibility: VisibilityIcon,
  hearing: HearingIcon,
  dentistry: LocalHospitalIcon,
  default: LocalHospitalIcon
};

/**
 * Renders the appropriate icon for a department
 * @param {string} iconName - The icon name from the database (optional)
 * @param {string} iconImageId - The icon image ID from the database (optional)
 * @param {object} sx - MUI sx props for styling
 * @returns {JSX.Element} The icon component
 */
export const DepartmentIcon = ({ iconName, iconImageId, sx = {} }) => {
  // Check if iconName might actually be an image ID (uploaded image)
  // If iconImageId is provided, or if iconName looks like an image ID (not a known icon name)
  const knownIconNames = ['emergency', 'favorite', 'psychology', 'child_care', 'accessibility', 'healing', 'local_hospital', 'medical_services', 'stethoscope', 'monitor_heart', 'brain', 'elderly', 'pregnant_woman', 'visibility', 'hearing', 'dentistry'];
  const isImageId = iconImageId || (iconName && !knownIconNames.includes(iconName));
  
  // If this is an uploaded icon image, display it
  if (isImageId) {
    const iconId = iconImageId || iconName;
    const imageUrl = `${getApiBaseUrl()}/images/${iconId}`;
    
    return (
      <Box
        component="img"
        src={imageUrl}
        alt="Department Icon"
        sx={{
          ...sx,
          objectFit: 'contain',
          borderRadius: '4px'
        }}
        onError={(e) => {
          // If image fails to load, fall back to default icon
          e.target.style.display = 'none';
        }}
      />
    );
  }
  
  // Otherwise use the icon name or default Material UI icon
  const IconComponent = iconName && iconMap[iconName] ? iconMap[iconName] : iconMap.default;
  return <IconComponent sx={sx} />;
};

/**
 * Gets the icon component for a department
 * @param {string} iconName - The icon name from the database
 * @returns {React.Component} The icon component
 */
export const getDepartmentIcon = (iconName) => {
  return iconName && iconMap[iconName] ? iconMap[iconName] : iconMap.default;
};

export default DepartmentIcon;

